module.exports = __webpack_public_path__ + "img/famen.fc964ab6.png";